export default __webpack_public_path__ + "static/media/pictogramBeaconFeesAndInterest40.bef6ded4.svg";